package com.example.mystybag.database.communication.db

import kotlinx.coroutines.CoroutineDispatcher
import kotlinx.coroutines.Dispatchers

// На Web Worker отговаря на main thread; mapToList трябва да се изпълнява там, за да получи отговора.
actual val databaseQueryDispatcher: CoroutineDispatcher = Dispatchers.Main
